import { useParams } from "react-router-dom";
import contentHooks from "../../hooks/contentHooks";
import { useEffect, useState } from "react";
import BackButton from "../../components/common/backButton";

const StoryTimeLineDetail = () => {
  const { id } = useParams();
  const [contentData, setContentData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const response = await contentHooks.sequenceDetail({ id: id });
        if (response.IsError) {
          setError(true);
        } else {
          setContentData(response);
        }
      } catch (err) {
        setError(true);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [id]);

  if (isLoading) {
    return (
      <div
        className="flex flex-col pt-[50px] bg-white"
        style={{ 
          minHeight: "calc(var(--vh, 1vh) * 100)",
          paddingBottom: "max(1.875rem, env(safe-area-inset-bottom))"
        }}
      >
        <BackButton text="" />
        <div className="flex items-center justify-center h-full">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div
        className="flex flex-col pt-[50px] bg-white"
        style={{ 
          minHeight: "calc(var(--vh, 1vh) * 100)",
          paddingBottom: "max(1.875rem, env(safe-area-inset-bottom))"
        }}
      >
        <BackButton text="" />
        <div className="flex-1 flex items-center justify-center">
          <p className="text-gray-500">데이터를 불러오는데 실패했습니다.</p>
        </div>
      </div>
    );
  }

  if (!contentData?.data) {
    return (
      <div
        className="flex flex-col pt-[50px] bg-white"
        style={{ 
          minHeight: "calc(var(--vh, 1vh) * 100)",
          paddingBottom: "max(1.875rem, env(safe-area-inset-bottom))"
        }}
      >
        <BackButton />
        <div className="flex-1 flex flex-col items-center justify-center gap-4">
          <div className="w-16 md:w-20 h-16 md:h-20 bg-gray-100 rounded-full flex items-center justify-center">
            <svg className="w-8 h-8 md:w-10 md:h-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <p className="text-gray-500 text-lg md:text-2xl font-medium">등록된 데이터가 없습니다</p>
          <p className="text-gray-400 text-sm md:text-lg">다른 스토리를 확인해보세요</p>
        </div>
      </div>
    );
  }

  return (
    <div
      className="flex flex-1 flex-col pt-[50px] h-full bg-white"
      style={{ 
        minHeight: "calc(var(--vh, 1vh) * 100)",
        paddingBottom: "max(1.875rem, env(safe-area-inset-bottom))"
      }}
    >
      <BackButton />
      <div className="flex flex-col px-[23px] md:px-[69px] mx-auto">
        <div className="flex flex-col pt-[40px]">
          <div className="text-center mb-[40px]">
            <h2 className="text-base md:text-2xl font-semibold mb-2">{contentData.data.title}</h2>
            <p className="text-sm md:text-xl text-[#FEC009]">{contentData.data.prepare}</p>
          </div>

          <div>
            <p className="text-base md:text-lg leading-[27px]">
              {contentData.data.text}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StoryTimeLineDetail;
